module.exports = __webpack_public_path__ + "static/media/builtinv2-IMG_3314.72feb086.png";